<template>
<v-card flat>
    <v-card-title v-if="items.length>0" class="ml-n2">Order Statistics</v-card-title>
    <v-card-text>
        <v-flex text-center>
            <progress-bar :show="fetchingData" size="70"></progress-bar>
        </v-flex>
        <v-row v-if="!fetchingData&&items.length>0">
            <v-row cols="6" sm="4" text-right>
                <row-item label="Total Business" :value="'₹ '+totalBusiness.toFixed(2)"></row-item>
            </v-row>
            <v-row cols="6" sm="4" text-right>
                <row-item label="Total Credit" :value="'₹ '+totalCredit"></row-item>
            </v-row>
            <v-row cols="6" sm="4" text-right>
                <row-item label="Total Orders" :value="totalOrders"></row-item>
            </v-row>
        </v-row>
        <v-card-title class="ml-n2" v-if="items.length>0">Order Details</v-card-title>
        <v-row>
            <div style="width:100%">
                <v-data-table @click:row="navigate" v-if="!fetchingData&&items.length>0" hide-default-footer :items-per-page="items.length"
                    :headers="headers" :items="items" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
                    <template v-slot:item.date="{item}" v-if="$vuetify.breakpoint.smAndUp">
                        <label>{{ item.date | dateTimeFormat }}</label>
                    </template>
                    <template v-slot:item.statusLog="{item}" v-if="$vuetify.breakpoint.smAndUp">
                        <order-status :status="item.currentStatus"></order-status>
                    </template>
                    <template v-slot:item="{item}" v-if="$vuetify.breakpoint.xsOnly">
                        <order-card :order="item"></order-card>
                    </template>
                </v-data-table>
                <v-flex v-else text-center>
                    <v-alert outlined color="grey lighten-1" icon="mdi-receipt" prominent>
                        <h1>No previous order found</h1>
                    </v-alert>
                </v-flex>
                <pagination v-if="show" @input="initComponent()" :changeRows="false" :api="apiCall" v-model="items" sort="-orderNo" :apiParams="`customer=${customerId}`"></pagination>
            </div>
        </v-row>
    </v-card-text>
</v-card>
</template>

<script>
import appConstants from "@/utils/appConstants";
import OrderCard from '@/components/OrderResponsiveCard'
export default {
    components: {
        OrderCard,
    },
    props: {
        customerId: {
            type: String
        },
    },
    data() {
        return {
            headers: [{
                    text: "Order Number",
                    align: "start",
                    value: "orderNo"
                },
                {
                    text: "Order Date",
                    align: "start",
                    value: "date"
                },
                {
                    text: "Customer",
                    value: "customer.displayName",
                    sortable: false
                },
                {
                    text: "Amount",
                    value: "total",
                    align: "right"
                },
                {
                    text: "Items",
                    value: "items.length",
                    align: "right",
                    sortable: this.$vuetify.breakpoint.smAndUp
                },
                {
                    text: "Payment Status",
                    value: "pStatus",
                    align: "right",
                    sortable: this.$vuetify.breakpoint.smAndUp
                },
                {
                    text: "Delivery Status",
                    value: "statusLog",
                    align: "right"
                }
            ],
            sortBy: 'date',
            sortDesc: true,
            items: [],
            fetchingData: false,
            totalBusiness: 0,
            totalCredit: 0,
            totalOrders: 0,
            apiCall:appConstants.ORDERS_API,
            show:true
        }
    },
    methods: {
        initComponent(){
            if(this.items.length==0)
                this.show=false
            this.items.forEach(rec => {
                    this.totalBusiness = this.totalBusiness + rec.total
                    if (rec.balance)
                        this.totalCredit = this.totalCredit + rec.balance
                });
                this.totalOrders = this.items.length

        },
        navigate(order){
            this.$router.push("/app/orders/view/"+order._id)
        }
    },
}
</script>

<style lang="scss" scoped>
h4{
    padding: 0 1%;
    margin: 1%;
    font-weight: 400;
}
</style>
